import { V2ThemeProvider } from '@onevision-resources/design-theme';
import { useMemo } from 'react';
import { EllipsesMenu } from 'src/components';
import { sidePanelActionButtonSx } from 'src/components/SidePanelRow';
import { Address, Conversation } from 'src/graphql';
import { useSiteActions } from './use-site-actions';

interface SiteMenuProps {
  address: Address;
  conversation?: Conversation;
}

export const SiteMenu = ({ address, conversation }: SiteMenuProps) => {
  const {
    openSite,
    updateSite,
    copySiteId,
    copySiteUrl,
    copyTOS,
    copyLandingPageUrl,
    changeSites,
    disassociateSite,
    mergeSite,
    deleteSite,
  } = useSiteActions({
    address,
    conversation,
  });

  const menuOptions = useMemo(
    () =>
      [
        openSite,
        updateSite,
        changeSites,
        copySiteId,
        copySiteUrl,
        copyTOS,
        copyLandingPageUrl,
        mergeSite,
        disassociateSite,
        deleteSite,
      ]
        .filter((option) => ('isAllowed' in option ? option.isAllowed : true))
        .map((option) => ({
          ...option,
          onClick: option.handler,
        })),
    [
      openSite,
      updateSite,
      changeSites,
      disassociateSite,
      copySiteId,
      copySiteUrl,
      copyTOS,
      copyLandingPageUrl,
      mergeSite,
      deleteSite,
    ],
  );

  if (!menuOptions.length) {
    return null;
  }

  return (
    <V2ThemeProvider>
      <EllipsesMenu
        options={menuOptions}
        icon="more-vertical"
        iconLibrary="lucide"
        triggerTestId="site-menu-trigger"
        sx={sidePanelActionButtonSx}
      />
    </V2ThemeProvider>
  );
};
